import { createAxiomLogger, type LogContext } from "@baseline/lib/axiom";

export type { LogContext };

let _logger: ReturnType<typeof createAxiomLogger> | null = null;

export function initAxiom(token: string, dataset = "logs") {
	_logger = createAxiomLogger({
		token,
		dataset,
		source: "frontend",
		branch: import.meta.env.VITE_GIT_BRANCH || "local",
		consoleLog: true,
	});
}

export const axiomLog = {
	info: (message: string, context?: LogContext) =>
		_logger?.axiomLog.info(message, context),
	warn: (message: string, context?: LogContext) =>
		_logger?.axiomLog.warn(message, context),
	error: (message: string, context?: LogContext) =>
		_logger?.axiomLog.error(message, context),
	debug: (message: string, context?: LogContext) =>
		_logger?.axiomLog.debug(message, context),
};

// Flush logs before page unload
if (typeof window !== "undefined") {
	window.addEventListener("beforeunload", () => {
		_logger?.axiomClient?.flush();
	});
}
